export default __webpack_public_path__ + "45aa34e8592e191b741f98c07a63463d.svg";